import { Icon } from '@iconify/react'
import { useDispatch } from 'react-redux'
import { showErrorToast } from '../../../utils/showToast'
import { auth_logout_action } from '../../../context/actions/auth_action'
import { Button } from '../../../components/ui/legacy'

function LoginFail() {
  const dispatch = useDispatch()

  const errorOnclick = () => {
    showErrorToast('Báo lỗi sẽ được implement sau')
  }

  const redirectSignInHandler = () => {
    dispatch(auth_logout_action())
  }

  return (
    <>
      <p className="grid grid-cols-1 gap-2 text-center text-lg font-semibold leading-relaxed sm:text-2xl">
        <span>Đăng nhập thất bại</span>
        <span>Tài khoản chưa được phân quyền truy cập vào hệ thống</span>
      </p>

      <Button
        variant={'primary'}
        onClickHandler={redirectSignInHandler}
        className="gap-2 font-semibold sm:text-lg"
        rounded="lg"
        size="py-3 px-6"
      >
        <Icon icon="ph:arrow-bend-up-left-bold" className="text-3xl" />
        Quay lại trang đăng nhập
      </Button>
      <p
        className="text-md cursor-pointer text-center font-semibold text-gray-secondary underline hover:text-gray-accent"
        onClick={errorOnclick}
      >
        Báo lỗi
      </p>
    </>
  )
}

export default LoginFail
